import { cn } from "@/lib/utils"

export interface AlgoBuilderLogoProps {
  height?: number
  onClick?: () => void
  className?: string
}

export function AlgoBuilderLogo({ height = 22, onClick, className }: AlgoBuilderLogoProps) {
  return (
    <svg
      onClick={onClick}
      height={height}
      width={Math.round(height * (765 / 129))}
      viewBox="0 0 765 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="AlgoBuilder"
      className={cn(
        "block shrink-0 text-foreground",
        onClick ? "cursor-pointer" : "cursor-[inherit]",
        className,
      )}
    >
      <defs>
        <linearGradient
          id="abl-p0"
          x1="56.2634"
          y1="99.5705"
          x2="1.52755"
          y2="61.038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="abl-p1"
          x1="71.5131"
          y1="25.5109"
          x2="111.798"
          y2="63.1697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="abl-p2"
          x1="103.845"
          y1="53.8061"
          x2="66.6255"
          y2="141.82"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="abl-p3"
          x1="42.1898"
          y1="69.4583"
          x2="23.7998"
          y2="-25.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
      </defs>

      <path
        d="M156.058 108.68L187.672 20.3506H201.997L233.611 108.68H222.003L213.235 83.5497H176.434L167.666 108.68H156.058ZM180.015 73.0994H209.653L194.834 29.6812L180.015 73.0994Z"
        fill="currentColor"
      />
      <path
        d="M252.683 108.68C248.896 108.68 245.808 107.685 243.421 105.694C241.033 103.704 239.84 100.552 239.84 96.2392V20.3506H250.213V95.3684C250.213 96.6954 250.542 97.7321 251.201 98.4786C251.942 99.1421 252.971 99.4738 254.288 99.4738H259.969V108.68H252.683Z"
        fill="currentColor"
      />
      <path
        d="M293.156 128.834C288.464 128.834 284.224 128.046 280.437 126.47C276.65 124.894 273.48 122.655 270.928 119.752C268.376 116.849 266.647 113.49 265.741 109.675L276.608 108.929C277.596 111.998 279.325 114.403 281.795 116.144C284.347 117.969 288.134 118.881 293.156 118.881C299.084 118.881 303.612 117.679 306.741 115.274C309.951 112.868 311.557 109.261 311.557 104.45V93.7511C309.993 97.2345 307.482 100.013 304.024 102.086C300.566 104.16 296.697 105.197 292.415 105.197C286.899 105.197 281.96 103.828 277.596 101.091C273.315 98.3542 269.94 94.5805 267.47 89.7701C265.083 84.9596 263.889 79.4442 263.889 73.2238C263.889 66.9205 265.083 61.4051 267.47 56.6776C269.858 51.8672 273.151 48.0935 277.349 45.3565C281.63 42.6196 286.488 41.2511 291.922 41.2511C296.532 41.2511 300.648 42.3293 304.271 44.4857C307.975 46.6421 310.569 49.5449 312.051 53.1942V42.744H321.93V104.201C321.93 109.344 320.778 113.739 318.472 117.389C316.167 121.121 312.874 123.941 308.593 125.848C304.312 127.839 299.166 128.834 293.156 128.834ZM292.909 95.244C298.508 95.244 302.995 93.2949 306.37 89.3968C309.746 85.4158 311.474 80.0248 311.557 73.2238C311.639 68.6622 310.898 64.7641 309.334 61.5295C307.852 58.212 305.67 55.6824 302.789 53.9407C299.99 52.116 296.697 51.2037 292.909 51.2037C287.146 51.2037 282.66 53.1942 279.449 57.1753C276.32 61.0734 274.756 66.4229 274.756 73.2238C274.756 80.0248 276.361 85.4158 279.572 89.3968C282.865 93.2949 287.311 95.244 292.909 95.244Z"
        fill="currentColor"
      />
      <path
        d="M362.31 110.173C356.3 110.173 351.031 108.763 346.503 105.943C341.975 103.123 338.476 99.1421 336.006 93.9999C333.536 88.7748 332.302 82.6788 332.302 75.712C332.302 68.6622 333.536 62.5663 336.006 57.4241C338.476 52.2819 341.975 48.3008 346.503 45.4809C351.031 42.661 356.3 41.2511 362.31 41.2511C368.32 41.2511 373.548 42.661 377.994 45.4809C382.522 48.3008 386.021 52.2819 388.49 57.4241C390.96 62.5663 392.195 68.6622 392.195 75.712C392.195 82.6788 390.96 88.7748 388.49 93.9999C386.021 99.1421 382.522 103.123 377.994 105.943C373.548 108.763 368.32 110.173 362.31 110.173ZM362.31 100.22C368.32 100.22 372.972 98.0639 376.265 93.7511C379.64 89.3554 381.328 83.3423 381.328 75.712C381.328 68.0817 379.64 62.1101 376.265 57.7973C372.972 53.4016 368.32 51.2037 362.31 51.2037C356.3 51.2037 351.607 53.4016 348.232 57.7973C344.857 62.1101 343.169 68.0817 343.169 75.712C343.169 83.3423 344.857 89.3554 348.232 93.7511C351.607 98.0639 356.3 100.22 362.31 100.22Z"
        fill="currentColor"
      />
      <path
        d="M404.109 108.68V20.3506H434.241C444.615 20.3506 452.395 22.2582 457.581 26.0734C462.768 29.8885 465.362 35.9016 465.362 44.1125C465.362 47.9276 464.538 51.2866 462.892 54.1895C461.245 57.0923 458.899 59.3731 455.853 61.0319C452.806 62.6077 449.184 63.3956 444.985 63.3956L444.862 62.6492C452.354 62.6492 458.24 64.6812 462.521 68.7452C466.885 72.7262 469.066 77.9513 469.066 84.4205C469.066 92.4655 466.473 98.5201 461.286 102.584C456.1 106.648 448.731 108.68 439.181 108.68H404.109ZM414.73 98.2298H439.181C445.191 98.2298 449.801 96.9857 453.012 94.4975C456.305 92.0094 457.952 88.443 457.952 83.7985C457.952 79.1539 456.305 75.5461 453.012 72.975C449.801 70.321 445.191 68.994 439.181 68.994H414.73V98.2298ZM414.73 58.5437H434.241C440.663 58.5437 445.603 57.3411 449.061 54.9359C452.518 52.4478 454.247 49.0058 454.247 44.6101C454.247 39.9655 452.56 36.5236 449.184 34.2843C445.891 31.962 440.91 30.8008 434.241 30.8008H414.73V58.5437Z"
        fill="currentColor"
      />
      <path
        d="M502.899 110.173C496.395 110.173 491.168 107.975 487.216 103.579C483.346 99.1006 481.412 92.9632 481.412 85.167V42.744H491.785V82.3056C491.785 88.6918 492.896 93.4193 495.119 96.4881C497.424 99.4738 500.923 100.967 505.616 100.967C510.803 100.967 514.878 99.308 517.842 95.9904C520.806 92.59 522.288 87.9454 522.288 82.0568V42.744H532.661V108.68H522.782V92.3826L524.387 93.2535C523.07 98.6445 520.559 102.833 516.854 105.819C513.149 108.721 508.498 110.173 502.899 110.173Z"
        fill="currentColor"
      />
      <path
        d="M546.93 108.68V42.744H557.303V108.68H546.93ZM546.683 32.4181V20.2262H557.55V32.4181H546.683Z"
        fill="currentColor"
      />
      <path
        d="M585.012 108.68C581.225 108.68 578.138 107.685 575.75 105.694C573.363 103.704 572.169 100.552 572.169 96.2392V20.3506H582.542V95.3684C582.542 96.6954 582.871 97.7321 583.53 98.4786C584.271 99.1421 585.3 99.4738 586.617 99.4738H592.298V108.68H585.012Z"
        fill="currentColor"
      />
      <path
        d="M623.88 110.173C618.2 110.173 613.26 108.763 609.061 105.943C604.945 103.123 601.775 99.1421 599.552 93.9999C597.329 88.8577 596.218 82.7618 596.218 75.712C596.218 68.6622 597.329 62.5663 599.552 57.4241C601.775 52.2819 604.945 48.3008 609.061 45.4809C613.26 42.661 618.2 41.2511 623.88 41.2511C628.244 41.2511 632.237 42.2049 635.859 44.1125C639.481 45.9371 642.198 48.5497 644.009 51.9501V20.3506H654.383V108.68H644.997L644.627 98.7274C642.816 102.294 640.058 105.114 636.353 107.187C632.648 109.178 628.491 110.173 623.88 110.173ZM625.979 100.22C629.849 100.22 633.101 99.225 635.735 97.2345C638.452 95.244 640.51 92.4241 641.91 88.7748C643.31 85.0426 644.009 80.6883 644.009 75.712C644.009 70.5698 643.31 66.1741 641.91 62.5248C640.51 58.8755 638.452 56.0971 635.735 54.1895C633.101 52.199 629.849 51.2037 625.979 51.2037C620.217 51.2037 615.606 53.4016 612.148 57.7973C608.773 62.1101 607.085 68.0817 607.085 75.712C607.085 83.2594 608.773 89.2309 612.148 93.6267C615.606 98.0224 620.217 100.22 625.979 100.22Z"
        fill="currentColor"
      />
      <path
        d="M694.76 110.173C688.585 110.173 683.234 108.763 678.706 105.943C674.26 103.123 670.802 99.1421 668.333 93.9999C665.945 88.7748 664.751 82.6788 664.751 75.712C664.751 68.7452 665.945 62.6907 668.333 57.5485C670.802 52.4063 674.219 48.4253 678.582 45.6053C683.028 42.7025 688.256 41.2511 694.266 41.2511C699.947 41.2511 704.969 42.6196 709.332 45.3565C713.695 48.0106 717.071 51.9087 719.458 57.0508C721.928 62.193 723.163 68.4549 723.163 75.8364V78.9466H675.619C676.03 85.9964 677.883 91.3044 681.176 94.8708C684.551 98.4371 689.079 100.22 694.76 100.22C699.041 100.22 702.54 99.225 705.257 97.2345C708.056 95.161 709.991 92.4656 711.061 89.148L722.175 90.0189C720.446 95.9075 717.153 100.759 712.296 104.575C707.521 108.307 701.675 110.173 694.76 110.173ZM675.619 69.7404H711.802C711.308 63.3542 709.456 58.6682 706.245 55.6824C703.116 52.6966 699.123 51.2037 694.266 51.2037C689.244 51.2037 685.086 52.7795 681.793 55.9312C678.582 58.9999 676.524 63.603 675.619 69.7404Z"
        fill="currentColor"
      />
      <path
        d="M733.509 108.68V42.744H742.648L743.142 59.4146L742.154 59.0414C742.977 53.4016 744.747 49.2961 747.464 46.725C750.263 44.071 753.968 42.744 758.578 42.744H765V52.6966H758.702C755.409 52.6966 752.651 53.3186 750.428 54.5627C748.287 55.7238 746.641 57.507 745.488 59.9122C744.418 62.2345 743.883 65.2203 743.883 68.8696V108.68H733.509Z"
        fill="currentColor"
      />

      <g>
        <path
          d="M0 52.6843L0.0516929 70.5342C7.88329 70.5704 15.061 71.4207 22.2438 73.6435C44.7099 80.6455 53.5263 101.349 53.4513 123.89L71.2805 123.88C71.5441 112.512 69.6495 101.475 65.3409 91.0178C59.9802 78.4795 51.1639 68.2002 38.9641 61.5834C38.9641 61.5834 26.5732 55.039 0 52.6843Z"
          fill="url(#abl-p0)"
        />
        <path
          d="M125.135 71.2055L125.083 53.3557C117.252 53.3195 110.074 52.4691 102.891 50.2463C80.4251 43.2444 71.6088 22.541 71.6837 0L53.8545 0.010339C53.5909 11.3778 55.4855 22.4144 59.7942 32.872C65.1548 45.4104 73.9712 55.6897 86.1709 62.3064C86.1709 62.3064 98.5619 68.8509 125.135 71.2055Z"
          fill="url(#abl-p1)"
        />
        <path
          d="M125.135 52.6843L125.083 70.5342C117.252 70.5704 110.074 71.4207 102.891 73.6435C80.4251 80.6455 71.6088 101.349 71.6837 123.89L53.8545 123.88C53.5909 112.512 55.4855 101.475 59.7942 91.0178C65.1548 78.4795 73.9712 68.2002 86.1709 61.5834C86.1709 61.5834 98.5619 55.039 125.135 52.6843Z"
          fill="url(#abl-p2)"
        />
        <path
          d="M0 71.2055L0.0516929 53.3557C7.88329 53.3195 15.061 52.4691 22.2438 50.2463C44.7099 43.2444 53.5263 22.541 53.4513 0L71.2805 0.010339C71.5441 11.3778 69.6495 22.4144 65.3409 32.872C59.9802 45.4104 51.1639 55.6897 38.9641 62.3064C38.9641 62.3064 26.5732 68.8509 0 71.2055Z"
          fill="url(#abl-p3)"
        />
      </g>
    </svg>
  )
}
